// Base URLs for the FFTBG asset CDN. Centralized so the unit-portrait, item/skill-icon,
// and map-gif bases live in exactly one place (they were redefined ~19× across components
// under a half-dozen different names: UNIT_IMG / IMG_URL / CLASS_ICON_URL / PORTRAIT_BASE,
// ITEM_IMG / IMG_URL_ITEMS, MAP_IMG).
//
//   UNITS_BASE + '<Class><Gender>.gif'   → unit portrait  (e.g. 'KnightM.gif')
//   ICONS_BASE + '<ItemNameNoSpaces>.gif' → item / skill icon
//   MAPS_BASE  + '<n>.gif'                → battle-map gif

const CDN = 'https://luxor-fftbg-assets.s3.amazonaws.com/';

export const UNITS_BASE = CDN + 'units/';
export const ICONS_BASE = CDN + 'icons/';
export const MAPS_BASE = CDN + 'maps/';

// Generated site data (playerIndex, champHistory, …), published here by the refresh
// box (ops/publish.mjs) and read through a manifest by lib/dataStore.js.
export const DATA_BASE = CDN + 'data/';
